/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, ProjectProfileResponse } from './platformapi.schemas';

import setSaveProjectMutator from '../custom-axios-instance';
import getProjectByIdMutator from '../custom-axios-instance';

/**
 * Marks a project as saved / bookmarked for the current (pro) user, or removes the saved status.
 * @summary Set Save Project
 */
export const setSaveProject = (projectId: number, setSaved: boolean, signal?: AbortSignal) => {
  return setSaveProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/directory_projects/set_save_project/${projectId}/${setSaved}`,
    method: 'POST',
    signal,
  });
};

export const getSetSaveProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSaveProject>>,
    TError,
    { projectId: number; setSaved: boolean },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setSaveProject>>,
  TError,
  { projectId: number; setSaved: boolean },
  TContext
> => {
  const mutationKey = ['setSaveProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setSaveProject>>,
    { projectId: number; setSaved: boolean }
  > = (props) => {
    const { projectId, setSaved } = props ?? {};

    return setSaveProject(projectId, setSaved);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetSaveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof setSaveProject>>>;

export type SetSaveProjectMutationError = void | HTTPValidationError;

/**
 * @summary Set Save Project
 */
export const useSetSaveProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setSaveProject>>,
      TError,
      { projectId: number; setSaved: boolean },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setSaveProject>>,
  TError,
  { projectId: number; setSaved: boolean },
  TContext
> => {
  const mutationOptions = getSetSaveProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Project By Id
 */
export const getProjectById = (projectId: number, signal?: AbortSignal) => {
  return getProjectByIdMutator<ProjectProfileResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/directory_projects/${projectId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectByIdQueryKey = (projectId: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/directory_projects/${projectId}`] as const;
};

export const getGetProjectByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectByIdQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectById>>> = ({ signal }) =>
    getProjectById(projectId, signal);

  return { queryKey, queryFn, enabled: !!projectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectById>>>;
export type GetProjectByIdQueryError = void | HTTPValidationError;

export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectById>>,
          TError,
          Awaited<ReturnType<typeof getProjectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectById>>,
          TError,
          Awaited<ReturnType<typeof getProjectById>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project By Id
 */

export function useGetProjectById<
  TData = Awaited<ReturnType<typeof getProjectById>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectById>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectByIdQueryOptions(projectId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
